import { useEffect, useState } from "react";

import internalServerErrorLottie from "assets/files/internal-server-erorr-lottie.json";
import loadingWholeAppLottie from "assets/files/loading-whole-app-lottie.json";
import { LanguageID } from "configs";
import { useAuth } from "hooks/useAuth";
import useDidMountWithoutLifeCycle from "hooks/useDidMountWithoutLifeCycle";
import Lottie from "lottie-react";
import { useAppDispatch, useAppSelector } from "stores";
import { systemSlice } from "stores/System";
import { loadLocalStorage, saveLocalStorage } from "utils";

/**
 * Do things that is required for the app iniatilly.
 * e.g. take token, fetch user info, etc.
 */
export const AppInitializer = () => {
  const { initUserSession, isInitializing } = useAuth();
  const [loadedWholeApp, setLoadedWholeApp] = useState(true);
  const { internalServerError } = useAppSelector((state) => state.system);
  const dispatch = useAppDispatch();

  useDidMountWithoutLifeCycle(() => {
    if (
      !loadLocalStorage("lan") ||
      (loadLocalStorage("lan") &&
        !Object.values(LanguageID)?.includes(
          loadLocalStorage("lan") as LanguageID
        ))
    ) {
      saveLocalStorage("lan", LanguageID.vi);
      dispatch(systemSlice.actions.changeLanguage(LanguageID.vi));
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
    initUserSession();
  });

  useEffect(() => {
    const onPageLoad = () => setLoadedWholeApp(true);

    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);
    }

    return () => {
      window.removeEventListener("load", onPageLoad);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loadedWholeApp && !isInitializing ? null : (
        <Lottie
          animationData={loadingWholeAppLottie}
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
            zIndex: 999999,
            backgroundColor: "#fff",
          }}
        />
      )}
      {internalServerError && (
        <Lottie
          animationData={internalServerErrorLottie}
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
            zIndex: 999999,
            backgroundColor: "#fff",
          }}
        />
      )}
    </>
  );
};
